import React, { useState } from "react";
import styles from "./table.module.sass";
import cn from "classnames";
import Checkbox from "../../../Checkbox";
import Row from "./Row";

const Table = ({type, items, title }) => {

  const [chooseAll, setСhooseAll] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>Icon</div>
          <div className={styles.col}>Name</div>
          <div className={styles.col}>Types</div>
          <div className={styles.col}>Quantity</div>
          <div className={styles.col}>Uses Available</div>
          {type == 1 && <div className={styles.col}>Stack ID</div>}
          {type == 1 && <div className={styles.col}>Is Equiped</div>}
          {type == 1 && <div className={styles.col}>Is Opened</div>}
          <div className={styles.col}>Added At</div>
        </div>
        {items && items.map((x, index) => (
          <Row item={x} key={index} index={index} usedFor={type} />))}
      </div>
    </div>
  );
};

export default Table;
